// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Card, CardBody, Table } from 'reactstrap'
import Analyse from '../../../../Model/Analyse';
import ReferenzWertRows from './ReferenzWertRows'

type Props = {
  analyse: Analyse,
};

@observer
export default class ReferenzwertTab extends React.Component<Props, void> {
  render() {
    const { analyse } = this.props;

    return (
      <Table size="sm" striped style={{ marginTop: 8 }}>
        <tbody>
        <ReferenzWertRows analyse={analyse} />
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/ReferenzwertTab.js